/* RESPONSIBLE TEAM: team-standalone */
import Fragment from 'ember-data-model-fragments/fragment';
import { attr, type SyncHasMany } from '@ember-data/model';
import { type SalesforceCaseDescriptionSource } from 'embercom/models/operator/visual-builder/step/handoff-to-salesforce-case';
import { fragmentArray } from 'ember-data-model-fragments/attributes';
import type { Block } from 'embercom/models/common/blocks/block';

export default class HandoffToExternalTicketOnResolutionData extends Fragment {
  @attr('boolean') declare handoffEnabled: boolean;
  @attr('string') declare handoffToSalesforceOwnerId?: string;
  @attr('string') declare salesforceCaseDescriptionSource?: SalesforceCaseDescriptionSource;
  @attr('boolean') declare handoffOnIdleEnabled: boolean;

  @fragmentArray('common/blocks/block', { polymorphic: true, typeKey: 'modelKey' })
  declare salesforceCaseDescriptionBlocks?: SyncHasMany<Block>;

  @fragmentArray('common/blocks/block', { polymorphic: true, typeKey: 'modelKey' })
  declare salesforceCaseSubjectBlocks?: SyncHasMany<Block>;
}
